var map = {
	"./images/banner-1.jpg": 1439,
	"./images/banner-2.jpg": 7265,
	"./images/banner-3.jpg": 4387,
	"./images/phone/google-pixel4-clearlywhite-portrait.png": 4368,
	"./images/phone/google-pixel5-justblack-portrait.png": 2486,
	"./images/phone/iphone-xhr.png": 1939,
	"./images/phone/oneplus-oneplus8pro-portrait.png": 7427,
	"./images/phone/samsung-galaxys20-cosmicgrey-portrait.png": 9817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7922;